export const clearPolylines = (polylines: naver.maps.Polyline[]) => {
  for (const polyline of polylines) {
    polyline.setMap(null);
  }
};
